import React from 'react'

import { StyleSheet, Text } from '@react-pdf/renderer'

const styles = StyleSheet.create({
  variableContent: {
    color: 'black',
  },
})

const ComplianceListVariableReport = ({ complianceListData }) => {

  return (
    <Text style={styles.variableContent}>
      {complianceListData
        ? `Encontra-se na "${complianceListData}".`
        : "Não se encontra na Compliance List."}
    </Text>
  )
}

export default ComplianceListVariableReport
